import create from 'zustand';
import { persist } from 'zustand/middleware';
import { UserDetail } from 'modules/user-profile/types/user.types';
import createContext from 'zustand/context';
import { CustomerAffinity, PoliciesStatus } from 'modules/policies/types/policy.types';

interface StoreState {
  userDetail: UserDetail;
  setUserDetail: (userDetail: UserDetail) => void;
  setCustomerAffinity: (customerAffinity: CustomerAffinity) => void;
  customerAffinity: CustomerAffinity;
}
interface UserProviderProps {
  userStoreDetail: UserDetail;
}

export const useUserStore = create<StoreState>(
  persist(
    (set) => ({
      userDetail: {} as UserDetail,
      customerAffinity: {} as CustomerAffinity,
      setUserDetail: (userDetail) => set({ userDetail }),
      setCustomerAffinity: (customerAffinity: CustomerAffinity) => set({ customerAffinity }),
    }),
    {
      name: 'userDetail-storage',
      getStorage: () => sessionStorage,
    }
  )
);
const { Provider, useStore: useUserProviderStore } = createContext<UserProviderProps>();

const UserProvider: React.FC<UserProviderProps> = ({ userStoreDetail, children }): JSX.Element => {
  return <Provider createStore={() => create<UserProviderProps>(() => ({ userStoreDetail }))}>{children}</Provider>;
};

export { UserProvider, useUserProviderStore };
